export default __webpack_public_path__ + "static/media/water-waves.9029fe4f.svg";